<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t(
                "placeholder.label_employee_over_time_request_search_code_name"
              )
            }}</label>
            <CInput
              v-model="searchData.info"
              :placeholder="
                this.$t(
                  'placeholder.label_employee_over_time_request_search_code_name'
                )
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_position") }}</label>
            <select
              class="form-control"
              v-model="searchData.positionId"
              @change="search"
            >
              <option value="0">{{
                $t("placeholder.label_employee_option_search")
              }}</option>
              <option
                :value="item.id"
                v-for="(item, index) in positions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_start_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.startDate"
              @emitDate="startDate"
              v-model="searchData.startDate"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_end_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.endDate"
              @emitDate="endDate"
              v-model="searchData.endDate"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.divisionCode"
              @change="search"
            >
              <option value="0">{{
                $t("placeholder.label_employee_option_search")
              }}</option>
              <option
                :value="item.code"
                v-for="(item, index) in divisions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
          <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_approve_person") }}</label>
            <CInput
              v-model="searchData.approvePerson"
              :placeholder="
                this.$t('placeholder.label_approve_person_over_time_request')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
      </CRow>
      <CRow>
      
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("fields.sabbatical.type_reason") }}</label>
            <select
              class="form-control"
              v-model="searchData.reason_type"
              @change="search"
            >
              <option value="0">{{ $t("employee.select_option") }}</option>
              <option
              v-for="(option, index) in reasonType"
                :key="index"
                :value="option"
                >{{
                  
                   $t(`commons.label_status_sabbatical_leave_type_${option}`)
                }}
                
                </option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_status") }}</label>
            <select
              class="form-control"
              v-model="searchData.status"
              @change="search"
            >
              <option value="0">
                {{ $t("employee.select_option") }}
              </option>
              <option value="1">{{
                $t("commons.label_status_sabbatical_leave_request_1")
              }}</option>
              <option value="2">{{
                $t("commons.label_status_sabbatical_leave_request_2")
              }}</option>
              <option value="3">{{
                $t("commons.label_status_sabbatical_leave_request_3")
              }}</option>
            </select>
          </div>
        </CCol>
         <CCol sm="3" class="btn-search text-center">
          <CButton class="btn-search-employee" @click.prevent="search">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <CButton class="btn-reset" @click="resetForm"
            >{{ $t("button.label_action_reset") }}
          </CButton>
        </CCol>
      </CRow>
     </CCard>
    <CRow v-if="totalSabbaticalLeaveRequests.total > 0"> 
      <CCol sm="12">
        <CCard class="employee-table1">
          <CCardBody class="car_body">
          <table class="table1">
                <th class="padding_table">Họ và tên </th>
                <th class="center">Người duyệt cấp 1</th>
                <th class="center">Người duyệt cấp 2</th>
              <tr v-for="(item, index) in totalSabbaticalLeaveRequests" :key="index">
                <td v-if="index != 'total' && index != ''" class="padding_table">{{index}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level1}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level2}}</td>
              </tr>
              <tr>
                <th class="padding_table">Tổng</th>
                <td colspan="2" class="center">{{totalSabbaticalLeaveRequests.total}}</td>
              </tr>
            </table>
            </CCardBody>
            </CCard>
          </CCol>
     </CRow>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                    >{{ item }}</option
                  >
                </select>
              </div>
              <template
                v-if="
                  sabbaticalLeaveRequests.data &&
                    sabbaticalLeaveRequests.data.length > 0
                "
              >
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("employee.label_employee_code") }}</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_position") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_division") }}
                    </th>
                    <th scope="col">{{ $t("commons.label_created_at") }}</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_date_start") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_date_end") }}
                    </th>
                    <th scope="col">
                      {{
                        $t("sabbatical-leave-request.label_number_days_leave")
                      }}
                    </th>
                    <th>{{ $t("commons.label_status_approval") }}</th>
                    <th scope="col">
                      {{ $t("commons.label_sabbatical_leave_type") }}
                    </th>
                    <th scope="col">{{ $t("commons.label_status") }}</th>
                    <th scope="col" class="action">
                      {{ $t("commons.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="
                      sabbaticalLeaveRequests.data &&
                        sabbaticalLeaveRequests.data.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in sabbaticalLeaveRequests.data"
                      :key="index"
                    >
                      <th scope="row">
                        {{
                          (sabbaticalLeaveRequests.current_page - 1) *
                            sabbaticalLeaveRequests.per_page +
                            index +
                            1
                        }}
                      </th>
                      <td>{{ item.employee_id }}</td>
                      <td>{{ item.employee ? item.employee.name : "" }}</td>
                      <td>
                        {{
                          item.employee
                            ? objectNotNull(item.employee.position)
                              ? item.employee.position.name
                              : ""
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          item.employee
                            ? objectNotNull(item.employee.department)
                              ? item.employee.department.name
                              : ""
                            : ""
                        }}
                      </td>
                      <td>{{ item.updated_at | formatDate }}</td>
                      <td>
                        {{ item.start_time }} {{ item.start_date | formatDate }}
                      </td>
                      <td>
                        {{ item.end_time }} {{ item.end_date | formatDate }}
                      </td>
                      <td v-if = "item.reason_type == 4">{{ Math.round(item.number_days_off * 8 * 60) }} Phút</td>
                      <td v-else >{{ item.number_days_off }} Ngày</td>
                      <td class="approval-status">
                        <ul>
                          <li
                            v-for="(employeeApproval,
                            key) in item.sabbatical_leave_approves"
                            :key="key"
                          >
                            <template
                              v-if="
                                parseInt(item.id) ===
                                  parseInt(
                                    employeeApproval.sabbatical_leave_request_id
                                  )
                              "
                            >
                              {{ employeeApproval.employees[0].name }} :
                              {{
                                $t(
                                  `overtime.employee_approval_${employeeApproval.status}`
                                )
                              }}
                            </template>
                          </li>
                        </ul>
                      </td>
                      <td>
                        {{
                          $t(
                            `commons.label_status_sabbatical_leave_type_${item.reason_type}`
                          )
                        }}
                      </td>
                      <td
                        v-bind:class="
                          item.status ? 'color-status-' + item.status : ''
                        "
                      >
                        <CBadge color="secondary">{{
                          $t(
                            `commons.label_status_sabbatical_leave_request_${item.status}`
                          )
                        }}</CBadge>
                      </td>
                      <td>
                        <router-link
                          :to="{
                            path: `/sabbatical-leave-requests/detail/${item.id}`
                          }"
                        >
                          <CButton
                            color="primary"
                            variant="outline"
                            square
                            size="sm"
                          >
                            {{ $t("button.label_action_show") }}
                          </CButton>
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="13" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";

export default {
  name: "Sabbatical",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_leave_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    DatePickerFormFlex
  },
  data() {
    return {
      searchData: {
        info: "",
        divisionCode: 0,
        positionId: 0,
        startDate: "",
        endDate: "",
        approvePerson: "",
        reason_type: 0,
        status: 0,
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        },
      },
      reasonType:[1,2,3,4]
    };
  },
  computed: {
    ...mapGetters({
      sabbaticalLeaveRequests:
        "sabbatical-leave-request/sabbaticalLeaveRequests",
      divisions: "commons/divisions",
      positions: "commons/positions",
      commonReasons: "sabbatical-leave-request/commonReasons",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "sabbatical-leave-request/pagination",
      totalSabbaticalLeaveRequests: "sabbatical-leave-request/totalSabbaticalLeaveRequests"
    })
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.searchData.startDate = data;
    },

    endDate(data) {
      this.searchData.endDate = data;
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },

    async getLists() {
      await this.$store.dispatch(
        "sabbatical-leave-request/listSabbaticalLeaveRequests",
        {
          optionPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          employeeInfo: this.searchData.info.toLowerCase(),
          divisionCode: this.searchData.divisionCode,
          positionId: parseInt(this.searchData.positionId),
          start_date: this.searchData.startDate,
          end_date: this.searchData.endDate,
          approvePerson: this.searchData.approvePerson.toLowerCase(),
          reason_type: this.searchData.reason_type,
          status: parseInt(this.searchData.status)
        }
      );
      this.searchData.paginate = this.pagination;
    },

    async search() {
      this.setLoading(true);
      try {
        await this.getLists();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.searchData.info = "";
      this.searchData.divisionCode = 0;
      this.searchData.positionId = 0;
      this.searchData.startDate = this.getDateSearch().firstDay;
      this.searchData.endDate = this.getDateSearch().lastDay;
      this.searchData.approvePerson = "";
      this.searchData.reason = 0;
      this.searchData.status = 0;
    },

    changePage(page) {
      this.getLists(this.searchData.itemsPerPage, page);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    }
  },
  created() {
    this.searchData.startDate = this.getDateSearch().firstDay;
    this.searchData.endDate = this.getDateSearch().lastDay;
    this.getLists();
  }
};
</script>

<style lang="scss" scoped>
.padding_table{
  padding: 0 5px;
}
.car_body{
      padding: 10px 31px;
}
.center{
  text-align: center;
}
  .row_table{
    padding: 15px;
  }
.table1{
    background: #f8f8f8;
    width: 50%;
    th,
    td{
      padding: 5px;
      border:1px solid #d8dbe0;
    }
}
  .employee-table1 {
    margin: 0;
    border-radius: 0;
  }
.employee {
  margin: -2rem -30px 30px -30px;
  .card{
   margin-bottom: 1rem;
  }
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .table-responsive {
    table.table {
      th {
        vertical-align: middle;
      }
      th.action {
        width: 100px;
      }
      td {
        vertical-align: middle;
      }
    }
  }
  .employee-table {
    margin: 0 20px 0 30px;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
  .btn-search {
    margin-top: 25px;
  }
  .btn-export {
    text-align: right;
    button {
      margin-bottom: 20px;
      margin-right: 22px;
    }
  }
  .btn-reset {
    background: #e8e5e5;
    padding: 8px;
    width: 120px;
  }
  td.color-status-3 {
    span.badge.badge-secondary {
      background: #dc1313;
      color: #ffffff;
    }
  }

  td.color-status-2 {
    span.badge.badge-secondary {
      background: #006400;
      color: #ffffff;
    }
  }
  .approval-status {
    min-width: 250px;
  }
  ul {
    list-style-type: none;
    padding-left: 0px;

    li {
      text-align: left;
    }
  }
}
@media only screen and (max-device-width: 767px) {
  .show-text-table {
    margin-top: 0.4rem;
  }
  .employee .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1610px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1610px;
    overflow-x: scroll;
  }
}
</style>
